import { FC, ReactElement } from 'react'
import { RewardStatus } from 'interfaces/bounty'
import { ModalStatusDescription } from 'components/features/pfm/RewardDetails/ModalStatusDescription'

type ModalProps = {
  onCloseClick: () => void
}

const STATUSES_CRYPTO: Partial<Record<RewardStatus, string>> = {
  cryptoPending: 'Order is in progress and can\'t be canceled',
  cryptoConfirmed: 'Your order was successfully completed.',
  cryptoCancelled: 'Your order was cancelled',
}

export const ModalCrypto: FC<ModalProps> = ({
  onCloseClick,
}): ReactElement => {
  return (
    <ModalStatusDescription
      title='Tracking your crypto order'
      statuses={ STATUSES_CRYPTO }
      onCloseClick={ onCloseClick }
    />
  )
}
